export const enforceLattinLettersMessage =
{
    id: 'enforceLatingLetters.tooltip',
    description: "Use Latin letters only",
    defaultMessage: "Use Latin letters only",
};